import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, Select, InputLabel, Box, Chip, Checkbox, ListItemText, Modal, Divider, CardActions, Autocomplete, Backdrop, CircularProgress, List, ListItem, ListItemButton } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import ReportsHeader from './ReportsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridValueGetterParams,GridCellParams, GridToolbarContainer, GridToolbarExport, GridRowHeightParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SelectChangeEvent } from '@mui/material';

import moment from 'moment';

import { formatDate } from '../../helpers/custom';
const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 365,  
    bgcolor: 'background.paper',
    borderRadius: '8px',  
    boxShadow: 24,
    p: 4,  
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Bad-Bag-Images-Report' }} />
        </GridToolbarContainer>
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    anchorEl: any;
    communities: any[];
    community: any;
    fromDate?: string | null;
    toDate?: string | null;
    personName: any[];
    pageSize: any;
    bagBags: any;
    filter: any;
    showImageModal: any;
    openModal: boolean;
    selectedUser: any;
    currentImage: string;
    title: any;
    type: any;
    start_date?: string | null;
    end_date?: string | null;
    description: any;
    url: any;
    showConfirmModal: boolean;
    selectedStatus: string;
    selectedRow: any;
    searchUserId:string;
    statusFilter:any;
    showNotifyAllModal:Boolean

}

class BadBagReport extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            anchorEl: null,
            communities: [],
            community: "",
            fromDate: formatDate(moment().startOf('month').format('YYYY-MM-DD'), 'Y-m-d'),
            toDate: formatDate(moment().endOf('month').format('YYYY-MM-DD'), 'Y-m-d'),
            personName: [],
            pageSize: 5,
            bagBags: [],
            filter: '',
            showImageModal: false,
            currentImage: '',
            openModal: false, 
            selectedUser: null,
            searchUserId: '',
            title: 'Non-compliant bag detected',
            type: '',
            start_date: formatDate(new Date(), 'Y-m-d'),
            end_date: formatDate(new Date(), 'Y-m-d'),
            description: '',
            url: '',
            showConfirmModal: false,
            selectedStatus: '',
            selectedRow: null,
            statusFilter: 'Pending',
            showNotifyAllModal: false,

        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.fetchCommunities();
        this.handleFetchReport();
    }

    public fetchCommunities() {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            let communities: any = [];
            communities.push({
                id: 0,
                name: 'All',
                type: 'All'
            });
            data.map((community: any) => {
                communities.push({
                    id: community.id,
                    name: community.name,
                    type: community.type
                });
            });
            this.setState({ communities: communities });
        });
    }
    handleStatusChange = (event: SelectChangeEvent, row: any) => {
        const newStatus = event.target.value as string;
        this.setState({
            showConfirmModal: true,
            selectedStatus: newStatus,
            selectedRow: row
        });
    }
    handleNotifyAllUsers = () => {
        const dynamicDescription = `We have detected non-compliant waste in your bag ({{BAG_BARCODE}}, pickup Date: {{PICKUP_DATE}}). As a result, your earnings for this bag will be Rs. 0.`;
        this.setState({
            showNotifyAllModal: true,
            title: 'Non-compliant bag detected',
            description: dynamicDescription,
        });
    }
    confirmStatusChange = () => {
        const { selectedStatus, selectedRow } = this.state;
        if(selectedStatus != selectedRow.status){
            this.setState({ showLoader: true });
            let body: any = {
                id: selectedRow.id,
                approval_status: selectedStatus
            }
            axios.post(`updateBadBagStatus`, body).then((response) => {
                if (response.data.success) {
                    this.setState({
                        showLoader: false,
                        showConfirmModal: false,
                        selectedStatus: '',
                        selectedRow: null,
                        showNotifyAllModal: false
                    });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored"
                    });
                    this.handleFetchReport();
                }else{
                    toast.error("Something went wrong", {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.setState({
                        showLoader: false,
                        showConfirmModal: false,
                        selectedStatus: '',
                        selectedRow: null,
                        showNotifyAllModal: false
                    });
                }
            }).catch((error) => {
                this.setState({
                    showLoader: false,
                    showConfirmModal: false,
                    selectedStatus: '',
                    selectedRow: null,
                    showNotifyAllModal: false
                });
                toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
    }



    handleFetchReport = (() => {
        if (this.state.fromDate && this.state.toDate) {
            this.setState({ showLoader: true });
            let params: any = {
                hierarchies: this.props.user.selectedHierarchyIds,
                start_date: this.state.fromDate,
                end_date: this.state.toDate,
                status: this.state.statusFilter
            };
            if (this.state.community && this.state.community.id) {
                params.community_id = this.state.community.id;
            }
            if (this.state.searchUserId !== "") {
                params.user_id = Number(this.state.searchUserId);
            }

            axios.get(`badBagImages`, { params }).then((response) => {
                let data: any = response.data.data;
                let bagBags: any = [];
                data.map((badBag: any) => {
                    bagBags.push({
                        id: badBag.id,
                        user_id: badBag.user_id,
                        community_name: badBag.community_name,
                        house_number: badBag.cust_hno,
                        pickup_date: badBag.pickup_date,
                        barcode: badBag.barcode,
                        type: badBag.type,
                        images: badBag.image_urls,
                        status: badBag.approval_status || "Pending",
                        notificationStatus: badBag.is_notification_sent
                    });
                });
                this.setState({ showLoader: false, bagBags: bagBags });
            }).catch((error) => {
                this.setState({ showLoader: false });
                console.log("error logs here", error);
                toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
    });

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);
        const renderMaskedCell = (params: GridCellParams) => (
            <Box
                component="span"
                sx={isUatEnvironment ? {
                    filter: 'blur(4px)',
                    opacity: 0.5,
                    userSelect: 'none',
                } : undefined}
            >
                {params.value}
            </Box>
        );

        const handleDownloadReport = (() => {
            toast.success("Report Downloaded", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
        const handleNotifyUser = (user: any) => {
            const barcode = user.barcode;
            const pickup_date = formatDate(user.pickup_date, 'd/m/Y');
            //   const dynamicDescription = `We have identified non-compliant waste in your bag(${barcode})`;
            const dynamicDescription = `We have detected non-compliant waste in your bag (${barcode}, pickup Date: ${pickup_date}). As a result, your earnings for this bag will be Rs. 0.`;
            this.setState({
                openModal: true,
                selectedUser: user,
                title: 'Non-compliant bag detected',
                description: dynamicDescription,
            });
        };
    
        const handleCloseModal = () => {
            this.setState({ openModal: false, selectedUser: null });
        };

        const handleConfirmNotify = () => {
            this.setState({ showLoader: true });
            let body: any = {
                id: this.state.selectedUser.id,
                title: this.state.title,
                description: this.state.description
            };
            axios.post(`notifyUserBadBag`, body).then((response) => {
                if (response.data.success) {
                    this.setState({
                        openModal: false,
                        title: '',
                        description: '',
                        showLoader: false
                    });
        
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored"
                    });
                    this.handleFetchReport();
                }else{
                    toast.error("Something went wrong", {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }).catch((error) => {
                this.setState({ showLoader: false });
                console.log("error logs here", error);
                toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
        
        /*const handleConfirmNotify_Old = async () => {
            try {
                this.setState({ showLoader: true });
        
              
                let formdata = new FormData();
                formdata.append('title', this.state.title);
                formdata.append('type', 'nonpromo');
                formdata.append('url', '');
        
                if (this.state.selectedUser) {
                    formdata.append('individual_users', this.state.selectedUser.user_id);
                }
        
                const today = moment().format('YYYY-MM-DD');
                const oneMonthLater = moment().add(1, 'months').format('YYYY-MM-DD');
                formdata.append('start_date', today);
                formdata.append('expiry_date', oneMonthLater);
                // formdata.append('description', '<p>We have identified non-compliant waste in your bag(<b>'+this.state.selectedUser.barcode+'</b>) and marked it as Bad Bag.</p>');
                formdata.append('description', this.state.description);
        
                // Fetch image as blob
                const imageUrl = this.state.selectedUser.images.split(',');
                if(imageUrl.length){
                    try {
                        const response = await fetch(imageUrl[0], {
                            method: 'GET',
                            headers: {
                                'Origin': window.location.origin, // Ensures the origin is included
                            }
                        });
                        if (!response.ok) {
                            throw new Error(`Error fetching image: ${response.statusText}`);
                        }
                        const imageBlob = await response.blob();
                        formdata.append('image[]', imageBlob, 'userImage.jpg');
                    } catch (error) {
                        const err = error as Error;  // Type casting
                        console.error('Error downloading image:', err.message);
                        
                        // Stop the loader in case of an error
                        this.setState({ showLoader: false });
            
                        // Show an error notification
                        toast.error('Something went wrong', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored"
                        });
                        return;
                    }
                }
        
                // Post the notification
                const response = await axios.post('addNotification', formdata, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
        
                // Handle the response
                if (response.data.success) {
                    this.setState({
                        openModal: false,
                        title: '',
                        type: '',
                        start_date: formatDate(new Date(), 'Y-m-d'),
                        end_date: formatDate(new Date(), 'Y-m-d'),
                        description: '',
                        url: '',
                        showLoader: false, // Stop the loader when done
                    });
        
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored"
                    });
        
                    handleFetchReport();
                } else {
                    this.setState({ openModal: false, showLoader: false, selectedUser: null });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored"
                    });
        
                    let errors = response.data.errors;
                    for (let error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored"
                        });
                    }
                }
            } catch (error) {
                const err = error as Error;  
                this.setState({ openModal: false, showLoader: false, selectedUser: null });
                console.error('Error posting notification:', err.message);
                
                toast.error(err.message || "An error occurred", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored"
                });
            }
        };*/
        
        const getImageName = ((image_url: string) => {
            let name = image_url.split("/")
            return name[name.length - 1];
        });

        const downloadImage = async (imageUrl: any) => {
            try {
                const downloadLink = document.createElement('a');
                downloadLink.href = imageUrl;

                downloadLink.setAttribute('download', getImageName(imageUrl));
                downloadLink.setAttribute('target', '_blank');

                document.body.appendChild(downloadLink);
                downloadLink.click();

                document.body.removeChild(downloadLink);
            } catch (error) {
                console.error('Error downloading image:', error);
            }
        };

        const downloadPDF = (() => {
            this.setState({ showLoader: true });
            let data: any = {
                hierarchies: this.props.user.selectedHierarchyIds,
                start_date: this.state.fromDate,
                end_date: this.state.toDate
            };
            if (this.state.community && this.state.community.id) {
                data.community_id = this.state.community.id;
            }
            if (this.state.searchUserId !== "") {
                data.user_id = Number(this.state.searchUserId);
            }
            axios.post('report/bad-bag-images', data, {
                responseType: 'blob',
            }).then((response: any) => {
                this.setState({ showLoader: false });
                let fileName = "Bad-Bag-Images-Report";
                const blob = new Blob([response.data], { type: response.headers['content-type'] });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
            }).catch((error) => {
                this.setState({ showLoader: false });
                console.log("error logs here", error);
                toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const confirmNotifyAllUsers = () => {
            if (this.state.fromDate && this.state.toDate && this.state.statusFilter == "Approved") {
                this.setState({ showLoader: true });
                let body: any = {
                    hierarchies: this.props.user.selectedHierarchyIds,
                    start_date: this.state.fromDate,
                    end_date: this.state.toDate,
                    title: this.state.title,
                    description: this.state.description
                };
                if (this.state.community && this.state.community.id) {
                    body.community_id = this.state.community.id;
                }
                axios.post(`notifyAllUsersBadBag`, body).then((response) => {
                    if (response.data.success) {
                        this.setState({
                            title: '',
                            description: '',
                            showNotifyAllModal: false, // Stop the loader when done
                        });
            
                        toast.success(response.data.msg, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored"
                        });
                        this.handleFetchReport();
                    }else{
                        toast.error("Something went wrong", {
                            position: "top-right",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }).catch((error) => {
                    this.setState({ showLoader: false });
                    console.log("error logs here", error);
                    toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                });
            }
        }

        const MenuProps = {
            PaperProps: {
                style: {
                    maxHeight: 48 * 4.5 + 8,
                    width: 250,
                },
            },
        };

        const names = [
            'Kg',
            'Price',
            'Bag',
            'Bad Bag'
        ];


        const columns: any = [
            {
                headerName: "ID",
                field: "id",
                hide: true
            },
            {
                headerName: "User ID",
                field: "user_id",
                width: 90
            },
            {
                headerName: "Community",
                field: "community_name",
                width: 200,
                renderCell: renderMaskedCell
            },
            {
                headerName: "H.No.",
                field: "house_number",
                width: 200,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Pickup Date",
                field: "pickup_date",
                width: 100
            },
            {
                headerName: "Barcode",
                field: "barcode",
                width: 120
            },
            {
                headerName: "Type",
                field: "type",
                width: 130
            },
            {
                headerName: "Images",
                field: "images",
                width: 180,
                renderCell: (params: GridCellParams) => (
                    <List>
                        {
                            params.row.images.split(',').map((image: string, imageKey: number) => {
                                return (<ListItem key={imageKey} disablePadding>
                                    {/* <ListItemButton onClick={() => this.setState({ showImageModal: true, currentImage: image })}>{getImageName(image)}</ListItemButton> */}
                                    <Button key={imageKey} fullWidth={true} variant='text' style={{ textDecoration: 'none' }} onClick={() => this.setState({ showImageModal: true, currentImage: image })}>{getImageName(image)}</Button>
                                </ListItem>)
                            })
                        }
                    </List>
                )
            },
             {
                headerName: "Status",
                field: "status",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <Select
                        value={params.row.status || "Pending"}
                        onChange={(event) => this.handleStatusChange(event, params.row)}
                        disableUnderline 
                        variant="standard" 
                        sx={{ width: '100%' }}
                    >
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Approved">Approved</MenuItem>
                        <MenuItem value="Declined">Declined</MenuItem>
                    </Select>
                )
            },
            {
                headerName: "Notification Status",
                field: "notificationStatus",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <Chip color={(params.row.notificationStatus) ? "success" : "error"} label={(params.row.notificationStatus) ? "Notified" : "Unnotified"} size="small" variant="outlined"/>
                )
            },
            {
                headerName: "Actions",
                field: "actions",
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <Button
                        variant="contained"
                        color="primary"
                        size='small'
                        onClick={() => handleNotifyUser(params.row)}
                        sx={{ padding: '2px 5px' }} 
                        disabled={params.row.status === "Pending" || params.row.status === "Declined"}
        >
                        Notify User
                    </Button>
                )
            },

        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                {this.props.user.role !== 'bad_bag_manager' && (<ReportsHeader user={this.props.user} />)}
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={1.3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "78px" }}>{t("Bad Bags")}</Typography>
                                        </Grid>
                                        {/* <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    // onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.fetchRoutes())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid> */}
                                        <Grid item md={1.5} xs={12} sx={{ mt: 2.3 }}>
                                            <FormControl fullWidth={true}>
                                                <TextField
                                                    label="User ID"
                                                    variant="outlined"
                                                    size="small"
                                                    value={this.state.searchUserId || ""}
                                                    onChange={(e) => this.setState({ searchUserId: e.target.value })}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            this.handleFetchReport();
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12} sx={{ mt:2.3}}>
                                            <FormControl fullWidth={true}>
                                                <Autocomplete
                                                    id="community-label"
                                                    options={this.state.communities.sort((a, b) => -b.type.localeCompare(a.type))}
                                                    groupBy={(community) => community.type}
                                                    getOptionLabel={(community) => community.name}
                                                    renderInput={(params: any) => <TextField {...params} label="Community" />}
                                                    onChange={(e: any, value: any) => this.setState({ community: value }, () => this.handleFetchReport())}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={1.5} xs={12} sx={{ mt:2.3}}>
                                            <FormControl fullWidth={true}>
                                                <Select
                                                    value={this.state.statusFilter}
                                                    onChange={(e) => this.setState({ statusFilter: e.target.value as string }, () => this.handleFetchReport())}
                                                    size="small"
                                                >
                                                    <MenuItem value="Pending">Pending</MenuItem>
                                                    <MenuItem value="Approved">Approved</MenuItem>
                                                    <MenuItem value="Declined">Declined</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={1.8} xs={6} sx={{ mt:2.3}}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        renderInput={(props) => <TextField {...props} size="small" />}
                                                        label="From Date *"
                                                        views={['year', 'month', 'day']}
                                                        value={this.state.fromDate}
                                                        onChange={(newValue: any) => {
                                                            this.setState({ fromDate: formatDate(newValue, 'Y-m-d') }, () => this.handleFetchReport());
                                                        }}
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={1.8} xs={6} sx={{ mt:2.3}}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        renderInput={(props) => <TextField {...props} size="small" />}
                                                        label="To Date *"
                                                        views={['year', 'month', 'day']}
                                                        value={this.state.toDate}
                                                        onChange={(newValue: any) => {
                                                            this.setState({ toDate: formatDate(newValue, 'Y-m-d') }, () => this.handleFetchReport());
                                                        }}
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        <Grid item md={2} xs={12} >
                                            <Box display="flex" flexDirection="column" gap={2}>
                                                        <Button size='small'  fullWidth variant='contained' sx={{ outline: 'none !important' }} onClick={() => downloadPDF()}>Download PDF</Button>
                                                    {/* </Grid> */}
                                                    {/* <Grid item md={2} xs={12}> */}
                                                        <Button 
                                                        size='small' 
                                                            fullWidth 
                                                            variant='contained' 
                                                            sx={{ outline: 'none !important' }} 
                                                            onClick={this.handleNotifyAllUsers}
                                                            disabled={this.state.statusFilter !== 'Approved' || !this.state.fromDate || !this.state.toDate}
                                                        >
                                                            Notify All Users
                                                        </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>  
                                </>
                                }
                                className="text-left"
                            // action={
                            //     <CardActions>
                            //         <Button size='large' fullWidth={true} variant='contained' sx={{ outline: 'none !important' }} disabled={!this.state.fromDate || !this.state.toDate} onClick={() => handleDownloadReport()}>{t("Download")}</Button>
                            //     </CardActions>
                            // }
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label="List of Barcoded Bags"
                                    columns={columns}
                                    getRowHeight={(params: GridRowHeightParams) => {
                                        return (params.model.images) ? params.model.images.split(',').length * 40 : 52;
                                    }}
                                    rows={this.state.bagBags}
                                    pageSize={this.state.pageSize}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    rowsPerPageOptions={[2, 5, 10, 20,100]}
                                    autoHeight={true}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Toolbar: CustomToolbar
                                    }}
                                    disableSelectionOnClick
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showImageModal}
                    onClose={() => this.setState({ showImageModal: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={getImageName(this.state.currentImage)}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showImageModal: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent style={{ height: '550px', overflowY: 'scroll' }}>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12} className='text-center'>
                                        <img src={this.state.currentImage} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} width={600} height={450} alt="" />
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showImageModal: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => downloadImage(this.state.currentImage)}>Download</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showConfirmModal}
                    onClose={() => this.setState({ showConfirmModal: false })}
                    aria-labelledby="confirm-status-change"
                    aria-describedby="confirm-status-change-description"
                >
                    <Box sx={modalStyle}>
                        <Typography id="confirm-status-change" variant="h6" component="h2">
                            Confirm Status Change
                        </Typography>
                        <Typography id="confirm-status-change-description" sx={{ mt: 2 }}>
                            Are you sure you want to change the status to {this.state.selectedStatus}?
                        </Typography>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={() => this.setState({ showConfirmModal: false })} sx={{ mr: 1 }} className='customCloseButton'>
                                Cancel
                            </Button>
                            <Button onClick={this.confirmStatusChange} variant="contained">
                                Confirm
                            </Button>
                        </Box>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                >
                    <Box sx={modalStyle}>
                        <Typography id="modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                            Confirm Notification
                        </Typography>
                        <Typography id="modal-description" sx={{ mb: 3 }}>
                            Are you sure you want to notify this user?
                        </Typography>
                       
                        <Box sx={{ mb: 2 }}>
        
                         <Typography variant="h6" sx={{ color: 'black', fontWeight: '600', mb: 1 }}>
                             Title:
                         </Typography>
                         <TextField
                             value={this.state.title}
                             onChange={(e) => this.setState({ title: e.target.value })}
                             fullWidth
                             sx={{
                                 mb: 2,
                                 '.MuiInputBase-input': { fontSize: '1.1rem', fontWeight: '500', color: 'black' },  
                             }}
                         />

    
    <Typography variant="h6" sx={{ color: 'black', fontWeight: '600', mb: 1 }}>
        Description:
    </Typography>
    <TextField
        value={this.state.description}
        onChange={(e) => this.setState({ description: e.target.value })}
        multiline
        rows={4}
        fullWidth
        sx={{
            '.MuiInputBase-input': { fontSize: '1rem', color: 'black' },  // Black input text for description
        }}
    />
</Box>


                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleConfirmNotify}
                                sx={{ minWidth: 100 }}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={handleCloseModal}
                                sx={{ minWidth: 100 }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Modal>
                <Modal
                    open={Boolean(this.state.showNotifyAllModal)}
                    onClose={() => this.setState({ showNotifyAllModal: false })}
                    aria-labelledby="notify-all-modal-title"
                    aria-describedby="notify-all-modal-description"
                >
                    <Box sx={modalStyle}>
                        <Typography id="notify-all-modal-title" variant="h6" component="h2">
                            Confirm Notify All Users
                        </Typography>
                        <Box sx={{ mb: 2 }}>
                            <Typography sx={{ color: 'black', fontWeight: '600', mb: 1 }}>
                                Title:
                            </Typography>
                            <TextField
                                value={this.state.title}
                                onChange={(e) => this.setState({ title: e.target.value })}
                                fullWidth
                                sx={{
                                mb: 2,
                                '.MuiInputBase-input': { fontSize: '1.1rem', fontWeight: '500', color: 'black' },  
                                }}
                            />
                            <Typography variant="h6" sx={{ color: 'black', fontWeight: '600', mb: 1 }}>
                                Description:
                            </Typography>
                            <TextField
                                value={this.state.description}
                                onChange={(e) => this.setState({ description: e.target.value })}
                                multiline
                                rows={4}
                                fullWidth
                                sx={{
                                '.MuiInputBase-input': { fontSize: '1rem', color: 'black' },  // Black input text for description
                                }}
                            />
                        </Box>
                        <Typography id="notify-all-modal-description" sx={{ mt: 2 }}>
                            Are you sure you want to notify all users with approved status?
                        </Typography>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={() => this.setState({ showNotifyAllModal: false })} sx={{ mr: 1 }} className='customCloseButton'>
                                No
                            </Button>
                            <Button onClick={confirmNotifyAllUsers} variant="contained">
                                Yes
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(BadBagReport))
